module.exports = __webpack_public_path__ + "img/206.d0ba934d.jpg";